import { render, staticRenderFns } from "./ServiceConfig.vue?vue&type=template&id=1f0109b3&"
import script from "./ServiceConfig.vue?vue&type=script&lang=js&"
export * from "./ServiceConfig.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports